'use client'

import PageProvider from '@/context/PageContext'

const SiteShell = ({
	lang,
	children,
}) => {
	return (<PageProvider lang={lang}>
		{children}
	</PageProvider>)
}

export default SiteShell
